import React from 'react';
import PropTypes from 'prop-types';
import Error from './error-screen';
import illustrations from '../assets/illustrations';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
export default function InternalServerError(props) {
  return /*#__PURE__*/React.createElement(Error, {
    title: "Something went wrong on our server",
    label: "Error 500",
    paddingBottom: 125,
    illustration: illustrations.Error500
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "We're really sorry for the inconvenience. Please try refreshing the page or come back later."), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.gray400
  }, "If the issue continues, please don't hesitate to", ' ', /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.advanceBlue400,
    textDecorationLine: "underline",
    onPress: props.onPressLink
  }, "contact us."), ' ', "We're here to assist you!"), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.advanceBlue400,
    textDecorationLine: "underline",
    onPress: props.onPressBack
  }, "Back to Home"));
}
InternalServerError.defaultProps = {
  onPressLink: () => null,
  onPressBack: () => null
};
InternalServerError.propTypes = {
  onPressLink: PropTypes.func,
  onPressBack: PropTypes.func
};
//# sourceMappingURL=500.js.map